/**
 * A2P-4452: the curated allowlist of job listing facets *below* grade + speciality (i.e. with a
 * location and/or work type segment) that stay indexable and listed in the sitemap.
 *
 * Every other location/work-type facet is served noindex,follow and left out of the sitemap -
 * the facet engine can generate thousands of these combinations, and most of them are empty or
 * near-duplicates of their grade + speciality parent. Entries here should be chosen on search
 * volume (owned by SEO), not on what the facet engine can produce.
 *
 * Each entry must be the page's exact canonical path (see buildCanonicalJobListingPath): lower
 * case, no trailing slash, segments in grade/speciality/location/work-type order, a known grade
 * slug, a root speciality from BASE_KNOWN_SPECIALITY_SLUGS, and a country/state/city location
 * slug - e.g.
 * '/jobs/listing/specialist-consultant/anaesthetics/new-south-wales/locum'. An allowlisted facet
 * with zero live results is still noindexed. __tests__/constants/indexableJobListingFacets.test.ts
 * fails on any entry the listing page wouldn't serve back at exactly this path.
 */
export const INDEXABLE_DEEP_JOB_LISTING_PATHS: ReadonlySet<string> = new Set<string>([]);
